import { Component, ChangeDetectionStrategy, OnInit, OnDestroy, Input } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { CLASS_TYPES } from '@ux/constants/travel-loader.constants';
import { DomManipulateService } from '@app/modules/core/services/dom-manipulate.service';
import { environment } from '@environment';

@Component({
  selector: 'app-travel-loader',
  templateUrl: './travel-loader.component.html',
  styleUrls: ['./travel-loader.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TravelLoaderComponent implements OnInit, OnDestroy {

  @Input() classType: string;
  @Input() domManipulateOff: boolean = false;

  public options: AnimationOptions = { path: environment.animation.url };
  public styles: Partial<CSSStyleDeclaration> = {
    ...environment.animation.options
  };

  constructor(
    private domManipulateService: DomManipulateService
  ) { }

  ngOnInit(): void {
    if (!this.typeFlexDate) this.disabledScoll();
  }

  ngOnDestroy(): void {
    this.enabledScoll();
  }

  get widthAnimation(): string {
    return environment.animation.options.width;
  }

  get heightAnimation(): string {
    return environment.animation.options.height;
  }

  get typeFlexDate(): boolean {
    return this.classType === CLASS_TYPES.FLEX_DATE;
  }

  private disabledScoll(): void {
    if (!this.domManipulateOff) this.domManipulateService.setBodyScroll(false);
  }

  private enabledScoll(): void {
    if (!this.domManipulateOff) this.domManipulateService.setBodyScroll(true);
  }

}
